import { createApp } from '@app/adapters/create-app'

import WorkflowStatus from './../screens/workflow-review/components/workflow-status'

onDomLoad(function ($dom) {
  $dom.find('.workflow-status-component').each(function () {
    const data = this.dataset

    const workflowStatusApp = createApp(WorkflowStatus, {
      workflowId: parseInt(data.workflowId, 10),
      workflowName: data.workflowName || '',
      workflowStatusId: parseInt(data.workflowStatusId, 10),
      workflowStatuses: JSON.parse(data.workflowStatuses || ''),
      enableStatusChange: data.enableStatusChange,
    })

    workflowStatusApp.mount(this)
  })
})
